import { environment } from "../../../../environments/environment.config";

export const mondayProjectsQuery = (mondayBoardId: number) => {
  return `query {
              boards(ids: [${mondayBoardId}]) {
                  items_page {
                      items {
                          id
                          name
                      }
                  }
              }
            }
      `;
};

export const mondayAppInfoQuery = (isAndroid: boolean) => {
  return `query {  
            items(ids:[${isAndroid ? environment.GLOBALS.MONDAY_LICENSE_ANDROID_ID : environment.GLOBALS.MONDAY_LICENSE_IOS_ID}]) {
             id 
             name  
                column_values {
                id 
                text 
                column { 
                        title 
                    }
                }  
            }  
           }`;
};
